// Définition des types pour les structures de données - à voir pour les passer dans apiReturns.ts
type Depot = {
    codeDepot: string;
};

type Compte = {
    email: string;
    defaut: boolean;
    depotsGestion: Depot[];
};

type Transporteur = {
    id: number;
    comptes: Compte[];
};

/**
 * Récupère l'email d'un transporteur en fonction de l'ID du transporteur et du dépôt
 * @param transporteurId - L'ID du transporteur
 * @param transporteurs - Tableau d'objets transporteur
 * @param depotDepart - L'objet dépôt de départ
 * @returns L'email du transporteur ou une chaîne vide si non trouvé
 */
export const getTransporteurEmail = (
    transporteurId: number | null | undefined,
    transporteurs: Transporteur[] | null | undefined,
    depotDepart?: Depot | null
): string => {

    console.log("getTransporteurEmail called with transporteurId: ", transporteurId, " depotDepart: ", depotDepart, " transporteurs: ", transporteurs);

    if (!transporteurId || transporteurId < 1) {
        return '';
    }

    if (!transporteurs || transporteurs.length < 1) {
        return '';
    }

    const transporteur = transporteurs.find(x => x.id === transporteurId);

    if (!transporteur || !transporteur.comptes || transporteur.comptes.length === 0) {
        return '';
    }
    
    const comptes = [...transporteur.comptes];
    comptes.sort((a, _b) => a.defaut ? -1 : 0);
    
    if (comptes.length === 0) {
        return '';
    }

    if (!depotDepart) {
        return comptes[0]!.email;
    }

    const filteredComptes = comptes.filter(compte => 
        compte.depotsGestion.some(depot => depot.codeDepot === depotDepart.codeDepot)
    );

    if (filteredComptes && filteredComptes.length > 0) {
        return filteredComptes[0]!.email;
    }

    return comptes[0]!.email;
};